import {Redirect, Route} from "react-router-dom";
import {useContext} from "react";
import AuthContext from "../contexts/AuthContext";

const UnauthorizedRoute = ({children, ...rest}) => {
    let {user} = useContext(AuthContext)

    return (
        <Route {...rest}>
            {user ? <Redirect to="/tournaments" /> : children}
        </Route>
    )
}

export default UnauthorizedRoute